"use strict";

var _regeneratorRuntime = require("/home/travis/build/ulabox/boksa/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.buildRequestParams = exports.buildCompleteRoute = exports.buildRequestQuery = exports.APIcall = void 0;

var _object = require("lodash/object");

var _config = require("./config");

var _vault = require("./vault");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var APIcall =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(route) {
    var params,
        response,
        payload,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.next = 3;
            return window.fetch(route, params);

          case 3:
            response = _context.sent;
            _context.prev = 4;
            _context.next = 7;
            return response.json();

          case 7:
            payload = _context.sent;
            return _context.abrupt("return", [response, payload]);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            console.error('APIcall', route, params, response, _context.t0);
            throw _context.t0;

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 11]]);
  }));

  return function APIcall(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.APIcall = APIcall;

var buildRequestQuery = function buildRequestQuery(key, value) {
  var connector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
  return "".concat(connector).concat(key, "=").concat(encodeURIComponent(value));
};

exports.buildRequestQuery = buildRequestQuery;

var buildCompleteRoute = function buildCompleteRoute(route, customerToken) {
  var connector = /\?/.test(route) ? '&' : '?';
  var isAuthRequest = /\/auth\//.test(route); // If customerToken is send to products/recommend request it will answer with customers basics, to avoid this we check the request

  var isRecommendationsRequest = /\/products\/recommend/.test(route);
  var queries = []; // Append api key to all the requests

  queries.push(buildRequestQuery('api_key', (0, _vault.getApiKey)(), connector)); // Append customer token if any and not for auth-type requests or products recommendations

  if (customerToken && !isAuthRequest && !isRecommendationsRequest) {
    queries.push(buildRequestQuery('customer_token', customerToken));
  }

  return [_config.API_ROOT, route].concat(queries).join('');
};

exports.buildCompleteRoute = buildCompleteRoute;

var buildRequestParams = function buildRequestParams() {
  var rsaaParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var language = arguments.length > 1 ? arguments[1] : undefined;
  return _objectSpread({}, rsaaParams, {
    headers: _objectSpread({}, (0, _object.get)(rsaaParams, 'headers', {}), {
      'Accept-Language': language
    })
  });
};

exports.buildRequestParams = buildRequestParams;

var _default = function _default(rsaa, customerToken, language) {
  var route = buildCompleteRoute(rsaa.route, customerToken);
  var params = buildRequestParams(rsaa.params, language);
  return APIcall(route, params);
};

exports.default = _default;